import { Button, IconButton } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import { useContextWithGuard } from "../helpers/useContextWithGuard";
import { FavouritesContext } from "./favouritesProvider";

interface DeleteFolderButtonProps {
    folderId: number | undefined;
}

export const DeleteFolderButton = (props: DeleteFolderButtonProps) => {
    const { deleteFolder } = useContextWithGuard(FavouritesContext, "AlbumContext");

    return (
        <IconButton
            size="large"
            edge="start"
            aria-label="Delete folder"
            sx={{
                mr: 2,
                border: 'none !important',

            }}
            aria-haspopup="true"
            onClick={() => {
                if (props.folderId && props.folderId > 0) {
                    deleteFolder(props.folderId);
                }
            }}
            title="delete folder"
            color="primary"
        >
            <DeleteIcon />
        </IconButton>
    )
}